import type {
  BotStageAnswerApiCreationQuery,
  BotStageApi,
  BotQuestionApi,
} from "@/Modules/Models/Api/FlexoBot";

import TherapySideApiService from "./utils/TherapyApi";
class FlexoApiConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  async createAnswers(createQuery: BotStageAnswerApiCreationQuery): Promise<BotQuestionApi> {
    return this.ApiService.post<BotStageAnswerApiCreationQuery, BotQuestionApi>({
      endpoint: "/v1.0/flexo/answers",
      body: createQuery,
    });
  }

  getCurrentStages(): Promise<BotStageApi> {
    return this.ApiService.get<void, BotStageApi>({
      endpoint: "/v1.0/flexo/stages/current",
    });
  }

  getQuestionById(id: string): Promise<BotQuestionApi> {
    return this.ApiService.get<void, BotQuestionApi>({
      endpoint: `/v1.0/flexo/questions/${id}`,
    });
  }
}

export default FlexoApiConnector;
